module.exports = __webpack_public_path__ + "img/LQC_EN.4c31fc9f.jpg";